import { ConnectionLayout } from 'components/login/ConnectionLayout';
import React from 'react';

import { LoadingText } from '@fragment/ui/src/components/LoadingText';
import { InlineLogo } from '@fragment/ui/src/components/Logo/Logo';

export const TopLevelLoader = () => (
  <ConnectionLayout
    title={
      <>
        Connect to <InlineLogo />
      </>
    }
  >
    <div role="status" aria-label="Loading">
      <LoadingText text="Preparing your workspace" />
    </div>
  </ConnectionLayout>
);
